export default __webpack_public_path__ + "static/media/eudes.f5229868.png";